import {app_name} from './constants';

export default {
    computed:{
        appName(){
            return app_name;
        }
    }
}